export const uk = {
    placeholder: 'Введите минус-фразу'
};
